import React from "react";
import { cn } from "@/lib/utils";

export const AnimatedGradientText: React.FC = () => {
  return (
    <div className="w-full flex items-center justify-center py-4 px-4">
      <div className="group relative mx-auto flex items-center justify-center rounded-full px-6 py-3 shadow-[inset_0_-8px_10px_#8fdfff1f] transition-shadow duration-500 ease-out hover:shadow-[inset_0_-5px_10px_#8fdfff3f]">
        <span
          className={cn(
            "absolute inset-0 block h-full w-full animate-gradient rounded-[inherit] bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px]",
          )}
          style={{
            WebkitMask:
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "destination-out",
            mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            maskComposite: "subtract",
            WebkitClipPath: "padding-box",
          }}
        />
        <span className="text-xs md:text-sm font-medium animate-gradient bg-gradient-to-r from-[#ffaa40] via-[#9c40ff] to-[#40c9ff] bg-clip-text text-transparent bg-[length:300%_100%]">
          Log in to earn loyalty rewards! 🎉
        </span>
      </div>
    </div>
  );
};

export default AnimatedGradientText;
